// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"61321b80","434":"07709319","515":"ca774653","667":"30b1d8b8","736":"c932411b"}[chunkId] + ".css";
};